import React, { useContext } from 'react'

import { TColorsName } from 'styled-components'

import { ThemeContext } from 'providers/theme'

import { CustomIcon } from './styles'
import PathSvg from './svg'
import { IconProps, PathProps, TIcons } from './types'

const Icon = ({ icon, color, size, ...rest }: IconProps) => {
  const path = PathSvg[icon as keyof TIcons]

  return path ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size ?? '24px'}
      height={size ?? '24px'}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      {Array.isArray(path) ? (
        path.map(p => <Path key={p} d={p} color={color} />)
      ) : (
        <Path d={path} color={color} />
      )}
    </svg>
  ) : (
    <CustomIcon src={icon ?? rest.src} size={size || '30px'} {...rest} />
  )
}

const Path = ({ d, color }: PathProps) => {
  const { theme } = useContext(ThemeContext)

  return (
    <path
      d={d.toString()}
      fill={
        color && theme.colors[color as TColorsName]
          ? theme.colors[color as TColorsName]
          : color || theme.colors.dark
      }
      style={{ transition: '.4s' }}
    />
  )
}
export default Icon
